import { Component, OnDestroy, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, Subscription, debounceTime } from "rxjs";
import { RequestStatus } from "../enums/request-status.enum";
import { AccessService } from "../services/access.service";
import { AppHttpService } from "../services/app-http.service";
import { LoaderService } from "../services/loader.service";
import { NotificationService } from "../services/notification.service";
import { User } from "../models/user.model";
import { UserService } from "../services/user.service";

@Component({
  selector: 'base',
  template: ''
})
export abstract class BaseComponent implements OnDestroy{

  requestStatus = RequestStatus.None;
  REQUEST_STATUS = RequestStatus;

  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  protected subscription = new Subscription();
  protected loaderService: LoaderService= inject(LoaderService);
  protected notificationService: NotificationService= inject(NotificationService);
  protected searchDebounceSubject = new Subject<any>();
  protected httpService = inject(AppHttpService);
  protected accessService = inject(AccessService);
  protected userService = inject(UserService);


  setupSearchDebounceCallback(callback: Function) {
    this.searchDebounceSubject
      .pipe(debounceTime(300)) // Adjust the debounce time (in milliseconds) as per your needs
      .subscribe((event) => {
        callback(event);
      });
  }

  /**
   *
   * @param access Highest access id should passed
   * @param str1 Highest action string
   * @param str2 Fallback action string
   * @returns
   */
  getActionString(access: number | number[], str1: string, str2: string) {
    return this.accessService.checkAccess(access) ? str1 : str2;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  hasActiveSubscription(){
    const subscription = this.userService.hasActiveSubscription();
    return !!subscription;
  }

}
